var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Intro'),_c('BeeHeroPack'),_c('About'),_c('AboutBee')],1)}
var staticRenderFns = []

export { render, staticRenderFns }